import {
	getCheckboxFieldTemplate,
	getRadioFieldTemplate,
	securityGate
} from "../../../../../lib";
import ProgressBar from "./progress-bar";
import DOMHelper from "../../../../../lib/dom-helper";
import Api from "../../../../../lib/api";

export default class QuestionPage {
	constructor($root, mainController) {
		/* HTML elements */
		this.$root = $root;

		this.$questionSection = this.$root.querySelector('.quiz-question');
		this.$answersSection = this.$root.querySelector('.quiz-options');

		this.$questionNumber = this.$questionSection.querySelector('.quiz-question_number');
		this.$questionText = this.$questionSection.querySelector('.quiz-question_text');
		this.$questionTip = this.$questionSection.querySelector('.quiz-question_description');
		this.$codeBlock = this.$questionSection.querySelector('.quiz-question_code');

		/* Components */
		this.mainController = mainController;
		this.progressBar = new ProgressBar(this.$root);

		this.currentQuestion = null;
	}

	init() {
		this.currentQuestion = this.mainController.getCurrentQuestion();
		this.progressBar.init(this.mainController.getTotalQuestions(), this.currentQuestion.index);
		this.render();
	}

	switchQuestionPage(dir) {
		const isNext = dir === 'next';
		this.mainController.updateState(isNext);
		this.currentQuestion = this.mainController.getCurrentQuestion();
		this.progressBar.next(this.mainController.getCurrentIndex());
		this.render();
	}

	saveUserAnswer() {
		let userAnswers = {};
		const $answerBlocksList = this.$answersSection.querySelectorAll('label');
		$answerBlocksList.forEach(($item) => {
			const $option = $item.closest('.quiz-options_item')
			const isChecked = !!$option.querySelectorAll('.checked').length;
			const id = $option.dataset.id;
			userAnswers[id] = isChecked ? '1' : '';
		});
		this.mainController.saveAnswer(userAnswers);
	}

	render() {
		this.setQuestionSection();
		this.setAnswerSection();
	}

	setQuestionSection() {
		this.$questionNumber.textContent = this.currentQuestion.index + 1;
		this.$questionText.textContent = this.currentQuestion.question;
		if (this.currentQuestion.description) {
			this.$questionTip.textContent = this.currentQuestion.description;
			DOMHelper.show(this.$questionTip);
		} else {
			DOMHelper.hide(this.$questionTip);
		}
		if (this.currentQuestion.code) {
			this.$codeBlock.textContent = this.currentQuestion.code;
			DOMHelper.show(this.$codeBlock);
		} else {
			DOMHelper.hide(this.$codeBlock);
		}
	}

	setAnswerSection() {
		this.$answersSection.innerHTML = '';
		this.currentQuestion.answers.forEach((item, i) => {
			this.setAnswer(item, i);
		});
	}

	setAnswer(data, index) {
		const answerText = data.answer;
		const answerField = this.currentQuestion.type === 'radio' ?
			getRadioFieldTemplate(answerText, 'group'):
			getCheckboxFieldTemplate(answerText);

		const answerElem = DOMHelper.createElement('div', {
			attributes: {
				class: 'quiz-options_item',
				'data-id': index
			},
			html: answerField,
			$parent: this.$answersSection
		});

		//if user has already answered this question set appropriate field selected
		if (data.answered === '1') {
			const $input = answerElem.querySelector('input');
			$input.checked = true;
			$input.closest('label').classList.add('checked');

		}
	}

	sendForm(userData) {
		const formData = Object.assign({}, userData);
		delete formData['fromStorage'];

		if (formData) {
			const resultData = this.mainController.getResult();

			formData['type'] = 'quiz';
			formData["ratio"] = resultData.ratio;
			formData["answers"] = resultData.questionList;
			formData["passGrade"] = resultData.quizPassGrade;
			formData["quizId"] = this.mainController.config.entryId;
			formData['quizTitle'] = this.mainController.getQuizTitle();
			if (securityGate(this.mainController.config.extraSlug)) {
				formData["quizExtraSlug"] = this.mainController.config.extraSlug;
			}

			Api.post(this.mainController.postUrl, formData)
				.catch((err) => {
					console.error('Quiz:', err);
				});
		} else {
			console.error('User data is not defined!');
		}
	}
}